import { DateTime } from "luxon";
import { Fragment, useEffect, useState } from "react";

export function AxisTime(dtString) {
  if (dtString === null || dtString === undefined) return "";

  const dt = DateTime.fromISO(dtString);
  return dt.toFormat("HH:mm");
}

export function AxisDate(dtString) {
  if (dtString === null || dtString === undefined) return "";

  const dt = DateTime.fromISO(dtString);
  return dt.toFormat("dd/MM/yyyy");
}

export function AxisDateWithDay(dtString) {
  if (dtString === null || dtString === undefined) return "";

  const dt = DateTime.fromISO(dtString);
  return dt.toFormat("EEE, dd/MM/yyyy");
}

export function AxisDateTimeFull(dtString) {
  if (dtString === null || dtString === undefined) return "";

  const dt = DateTime.fromISO(dtString);
  return dt.toFormat("dd/MM/yyyy HH:mm:ss");
}

export function AxisHoursWork(hours) {
  if (hours === null || hours === undefined) return "Not Set";
  const totalMins = hours * 60;
  const hrs = Math.floor(totalMins / 60);
  const mins = Math.round(totalMins % 60);
  var hourPlural = hrs !== 1 ? " hrs " : " hr ";
  var minutePlural = mins !== 1 ? " mins " : " min";
  return hrs.toString() + hourPlural + +mins.toString() + minutePlural;
}

export function AxisClock() {
  function getCurrentTime() {
    const dateObject = DateTime.now();
    return dateObject.toFormat("HH:mm, dd LLL yyyy");
  }

  const [time, setTime] = useState(getCurrentTime());
  useEffect(() => {
    setInterval(() => {
      const currentTime = getCurrentTime();
      setTime(currentTime);
    }, 10000);
  }, []);

  return <Fragment>{time}</Fragment>;
}

export function AddDaysToDate(days) {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + days);
  return currentDate.toISOString();
}
